module.exports = __webpack_public_path__ + "static/media/timetable.1fe0a239.png";